export const getBarTimeChartOptions = (multiDay = false) => ({
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    mode: "index",
    intersect: false,
  },
  scales: {
    x: {
      type: "time",
      time: {
        tooltipFormat: "dd/MM/yyyy HH:mm",
        displayFormats: {
          hour: multiDay ? "dd/MM HH:mm" : "HH:mm",
        },
        unit: "hour",
        stepSize: 1,
      },
      stacked: true,
      grid: {
        offset: false,
      },
    },
    y: {
      title: {
        font: {
          weight: "bold",
        },
      },
      stacked: true,
    },
  },
  plugins: {
    legend: {
      position: "bottom",
      display: true,
    },
    crosshair: {
      id: "crosshair",
      afterDatasetsDraw(chart) {
        if (!chart.tooltip || !chart.tooltip.active || !chart.tooltip.active.length) return;

        const activePoint = chart.tooltip.active[0];
        const xScale = chart.scales.x;

        if (!activePoint || activePoint.index === undefined) return;

        const meta = chart.getDatasetMeta(activePoint.datasetIndex);
        const point = meta?.data?.[activePoint.index];
        if (!point) return;

        const x = point.x;
        const canvasHeight = chart.chartArea.bottom;
        const canvasTop = chart.chartArea.top;

        const ctx = chart.ctx;
        ctx.save();
        ctx.strokeStyle = "rgba(0, 0, 0, 0.15)";
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(x, canvasTop);
        ctx.lineTo(x, canvasHeight);
        ctx.stroke();
        ctx.restore();
      },
    },
  },
});

export const getLiveChartOptions = () => ({
  animation: false,
  responsive: true,
  maintainAspectRatio: false,
  resizeDelay: 100,
  interaction: {
    mode: "x",
    intersect: false,
  },
  plugins: {
    legend: {
      position: "bottom",
      display: true,
    },
  },
  scales: {
    y: {},
  },
});

export function getAutoScaledUnit(dataArrays, baseUnit) {
  const unitScales = {
    W: [
      { threshold: 1e6, scaledUnit: "MW", divisor: 1e6 },
      { threshold: 1e3, scaledUnit: "kW", divisor: 1e3 },
    ],
    Wh: [
      { threshold: 1e6, scaledUnit: "MWh", divisor: 1e6 },
      { threshold: 1e3, scaledUnit: "kWh", divisor: 1e3 },
    ],
    VAr: [
      { threshold: 1e6, scaledUnit: "MVAr", divisor: 1e6 },
      { threshold: 1e3, scaledUnit: "kVAr", divisor: 1e3 },
    ],
  };

  const scales = unitScales[baseUnit];
  if (!scales) return { unit: baseUnit, divisor: 1 };

  const allValues = dataArrays.flat().filter((v) => v != null && !isNaN(v));
  if (allValues.length === 0) return { unit: baseUnit, divisor: 1 };

  const maxAbs = Math.max(...allValues.map((v) => Math.abs(v)));

  for (const { threshold, scaledUnit, divisor } of scales) {
    if (maxAbs >= threshold) {
      return { unit: scaledUnit, divisor };
    }
  }
  return { unit: baseUnit, divisor: 1 };
}

export function applyAutoScale(options, dataArrays, baseUnit) {
  const { unit, divisor } = getAutoScaledUnit(dataArrays, baseUnit);
  options.scales.y = options.scales.y || {};
  options.scales.y.title = { ...options.scales.y.title, display: true, text: unit, font: { weight: "bold" } };
  if (divisor !== 1) {
    options.scales.y.ticks = {
      ...options.scales.y.ticks,
      callback: (value) => +(value / divisor).toFixed(2),
    };
  }
  return { unit, divisor };
}
